import { responsiveJs } from './responsive';
export { tabs };

const tabs = () => {
    $("[data-tabs-group]", $("[data-tabs]")).on('click', function () {
        var $this = $(this);
        var $thisParentData = $this.parent().data('tabs');
        var $thisData = $this.data('tabs-group');
        $this.addClass('active').siblings().removeClass('active');
        $("[data-tabs] li[data-tabs-group=" + $thisData + "]").addClass("active").siblings().removeClass('active');
        $("[data-tabs-group=" + $thisData + "]", $("[data-tabs-content=" + $thisParentData + "]")).show().siblings("[data-tabs-group]").hide();
    
        $("html, body").animate({
            scrollTop: 0
        }, 300);
    })
    responsiveJs();
    
    $(document).on("click", ".show-login-register", function () {
        $('[data-popup="login-register-popup"]').show();
    
        return false;
    });
    $(document).on("click", ".call-login-btn", function () {
        $(".popup-overlay").hide();
    
        if (window.innerWidth < 769) {
            $("html, body").animate({
                scrollTop: 0
            }, 300);
            if (!$('body').hasClass('menu-open')) {
                $('body').addClass('overflow-hidden');
            }
        }
        $("#login-modal").show();
    
        let targetUrl = $(this).data("targetUrl");
        console.log("targetUrl", targetUrl);
        if (targetUrl) {
            $.get("/", {targetUrl: targetUrl}, function (res) {
                console.log("targetUrl saved");
            });
        }
    
        return false;
    });
    $(document).on("click", "[data-href]", function () {
        let href = $(this).data("href");
        document.location = href;
        return false;
    });
    
    $(".color-switcher").spectrum({
        preferredFormat: "hex",
        cancelText: "Katkesta",
        chooseText: "Kinnita värv",
        change: function (myColor) {
            var dataId = $(this).closest("td").data("id");
            var color = myColor.toHexString();
            $.getJSON(WWW_INDEX + "?f=" + MODULE_NAME, {
                mycolor: color,
                regcode: dataId
            });
        }
    });
    
    $('.price-list').click(function () {
        console.log(this);
        $(this).siblings().removeClass("active-price");
        $(this).addClass("active-price");
    
        console.log($(this).parent().find('input[type=radio]'));
    
        $(this).find('input[type=radio]').prop('checked', true);
        return false;
    });
    
    /*$('input[type=radio][name=kaardipakett]').change(function(e) {
        if ($(this).is(':checked')) {
            $(".price-list").removeClass("active-price");
            $(this).closest("div").addClass( "active-price" );
        }
    });*/
    
    if (MODULE_NAME === "hinnakalkulaator") {
        $($(".svg-tabs").get(0)).trigger("click");
    }
    
    MO.ready();
}